module.exports = __webpack_public_path__ + "static/media/icon3.bbb58081.svg";